import { apiService } from './api';

// ---------- Types ----------
export interface DashboardMetrics {
  totalServices: number;
  byCategory: Record<string, number>;
  estimatedMonthlyCost: number;
}

export interface RecentService {
  id: string;
  name: string;
  type: string;
  category: string;
  status: string;
  region?: string;
  endpointUrl?: string;
  publicDnsNameKubiy?: string;
  /** Tecnología de la app (ej. html, node, react) para APP_DEPLOY/SITE */
  technology?: string;
  /** Sistema operativo (ej. windows, ubuntu) para VM/COMPUTE */
  os?: string;
  /** Metadata adicional del backend. Para OS de VMs se usa: metadata.os, metadata.productOs, metadata.product?.os, metadata.product?.name, metadata.productName */
  metadata?: {
    databaseConfig?: { engine?: string };
    technology?: string;
    appConfig?: { type?: string };
    os?: string;
    productOs?: string;
    productName?: string;
    product?: { os?: string; name?: string };
  };
  createdAt: string;
  updatedAt: string;
}

export interface DashboardSummaryResponse {
  metrics: DashboardMetrics;
  recentServices: RecentService[];
}

export interface DashboardEvent {
  serviceId: string;
  serviceName: string;
  serviceCategory?: string;
  message: string;
  description?: string;
  level: 'INFO' | 'SUCCESS' | 'ERROR' | 'WARNING';
  type: string;
  phase?: string;
  source?: string;
  createdAt: string;
}

export interface DashboardActivityResponse {
  events: DashboardEvent[];
  total: number;
}

// ---------- Service ----------
class DashboardService {
  async getSummary(): Promise<DashboardSummaryResponse> {
    return apiService.get<DashboardSummaryResponse>('/dashboard/summary');
  }

  async getActivity(limit: number = 20): Promise<DashboardActivityResponse> {
    return apiService.get<DashboardActivityResponse>(
      `/dashboard/activity?limit=${limit}`
    );
  }
}

export const dashboardService = new DashboardService();